import React, { createContext, useContext, useState, ReactNode } from 'react';

interface YoutubeVideoContextType {
  video: VideoPlayer | null;
  setCurrentVideo: (video: VideoPlayer | null) => void;
  clearVideo: () => void;
}

const YoutubeVideoContext = createContext<YoutubeVideoContextType | undefined>(undefined);

interface YoutubeVideoProviderProps {
  children: ReactNode;
}

export const YoutubeVideoProvider: React.FC<YoutubeVideoProviderProps> = ({ children }) => {
  const [video, setVideo] = useState<VideoPlayer | null>(null);

  const setCurrentVideo = (video: VideoPlayer | null) => {
    setVideo(video);
  };

  const clearVideo = () => {
    setVideo(null);
  };

  const value: YoutubeVideoContextType = {
    video,
    setCurrentVideo,
    clearVideo,
  };

  return (
    <YoutubeVideoContext.Provider value={value}>
      {children}
    </YoutubeVideoContext.Provider>
  );
};

export const useYoutubeVideo = (): YoutubeVideoContextType => {
  const context = useContext(YoutubeVideoContext);
  return context || { video: null, setCurrentVideo: () => {}, clearVideo: () => {} };
};